import React from 'react';
import { QuantityContainer } from './ButtonInput.styled';
//@ts-ignore
import { Secondary } from '../../../eden/eden-buttons/lib/cjs';

//@ts-ignore
export const ButtonInput = ({ lowerQuantity, raiseQuantity, min, max, currentInput, onChange, onBlur, label, currentValue, id, ref }) => {
    return (
        <QuantityContainer>
            <Secondary onClick={currentInput > 0 ? () => lowerQuantity() : null}>-</Secondary>
            <input
                type='number'
                min={min}
                className='lds-quantity-input'
                pattern='[0-9]*'
                value={currentInput}
                onChange={onChange}
                onBlur={onBlur}
                aria-live='polite'
                aria-label={label}
                role='spinbutton'
                aria-valuemin={min}
                aria-valuemax={max}
                aria-valuenow={currentValue}
                id={id}
                ref={ref}
            />
            <Secondary onClick={currentInput < max ? () => raiseQuantity() : null}>+</Secondary>
        </QuantityContainer>
    );
};
